/** The contouring step's tool keys and radial menu. */
import { useToolHotkeys } from '~/components/toolbar/shared/useToolHotkeys';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';
import { useContouringToolEntries } from '~/components/toolbar/tools/ContouringTools/useContouringToolEntries';
import RadialToolMenu from '~/components/toolbar/radialMenu/RadialToolMenu';

export default function ContouringToolShortcuts() {
    const contouring = useContouringToolEntries();
    const viewing = useViewingToolEntries();
    useToolHotkeys([...Object.values(contouring), ...Object.values(viewing)]);
    // Clockwise from the top: the brush and its eraser side by side, pan at
    // the bottom.
    const menu = [
        contouring.staticBrush,
        contouring.adaptiveBrush,
        contouring.lineDraw,
        contouring.deform,
        viewing.pan,
        contouring.smoothBrush,
        contouring.transform,
        contouring.erase,
    ];
    return <RadialToolMenu entries={menu} />;
}
